import React, {Component} from 'react'
import ListItemMarkErrorPage from './ListItemMarkErrorPage'

class ListItemMarkErrorContainer extends Component{
    render() {
        return (
            <div>
                <ListItemMarkErrorPage/>
            </div>
        )
    }
}

export default ListItemMarkErrorContainer